module.exports = __webpack_public_path__ + "static/media/ManjimupBridgetownTimes-devicecomp-min@2x.b4a761a5.png";